export const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_komunika-infotech/artifacts/5hulk6sk_logo.png";

export const Logo = ({ size = 40, withText = true, inverse = false }) => {
  return (
    <div className="flex items-center gap-3" data-testid="brand-logo">
      <div
        className="shrink-0 grid place-items-center"
        style={{
          width: size,
          height: size,
          background: "#0F172A",
          border: "1px solid #0F172A",
        }}
      >
        <img
          src={LOGO_URL}
          alt="CV. Komunika Teknik"
          style={{ width: size - 6, height: size - 6, objectFit: "contain" }}
        />
      </div>
      {withText && (
        <div className="leading-tight">
          <div
            className={`font-display font-extrabold tracking-tight ${
              inverse ? "text-white" : "text-[#18181B]"
            }`}
            style={{ fontSize: size * 0.42 }}
          >
            KOMUNIKA TEKNIK
          </div>
          <div
            className={`text-[10px] font-semibold uppercase tracking-[0.25em] ${
              inverse ? "text-zinc-400" : "text-[#52525B]"
            }`}
          >
            CV · Information Technology
          </div>
        </div>
      )}
    </div>
  );
};

export default Logo;
